import { cva } from '@betterment/samba-styled-system/css';
import { NavLinkProps, NavLink as ReactRouterNavLink } from 'react-router-dom';

import { Icon } from './Icon';
import { Subtext } from './Subtext';
import { Text } from './Text';

export const navLinkStyles = cva({
  base: {
    borderRadius: 'medium',
    px: 'space.150',
    color: 'currentColor',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.150',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:has(+ &)': {
      mb: 'space.25',
    },
    '&[aria-current=page], &[data-active="true"]': {
      backgroundColor: 'primitives.white.100alpha30',
      _hover: { backgroundColor: 'primitives.white.100alpha30' },
    },
    _hover: { backgroundColor: 'primitives.white.100alpha15' },
  },
  variants: {
    spacing: {
      compact: { py: 'space.50' },
      default: { py: 'space.100' },
      expanded: { py: 'space.150' },
    },
  },
  defaultVariants: {
    spacing: 'default',
  },
});

export const Root: React.FC<React.PropsWithChildren<NavLinkProps>> = ({ children, ...rest }) => (
  <ReactRouterNavLink className={navLinkStyles()} {...rest}>
    {children}
  </ReactRouterNavLink>
);

export const NavLink = Object.assign(Root, {
  Icon,
  Subtext,
  Text,
});
